import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VehicleDetailPage } from '@/features/vehicle-detail/vehicle-detail-page';

/**
 * `to` — порт призначення, до якого рахується «Delivered» (UN/LOCODE). У
 * адресі, щоб посилання на лот із портом можна було переслати колезі.
 * Невалідне значення мовчки зникає, а не ламає сторінку (§11.1 гайду).
 */
const searchSchema = z.object({
	to: z.string().regex(/^[A-Z]{2}[A-Z0-9]{3}$/).optional().catch(undefined),
});

export const Route = createFileRoute('/auctions/$vehicleId')({
	validateSearch: searchSchema,
	component: VehicleDetailPage,
});
